import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {ITanneryDyeingSchedule} from "../../../../../../utils/interfaces/tannery_dyeing/ITanneryDyeingSchedule";


const useApiGetTanneryDyeingScheduleDrafts = (
    companyToken: string | undefined
): UseQueryResult<ITanneryDyeingSchedule[], CustomAxiosError> => {

    const {get} = useApiCalls();

    async function doGet(company_token: string | undefined): Promise<ITanneryDyeingSchedule[]> {
        try {
            const response = await get(`/api/company/${company_token}/tannery_dyeing/drafts`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }


    return useQuery({
        queryKey: ['getTanneryDyeingScheduleDrafts'],
        queryFn: () => doGet(companyToken)
    })
};

export default useApiGetTanneryDyeingScheduleDrafts